/**
 * @generated SignedSource<<2eb8c5ee6d080bcfd4b288b304a703b7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type teamMemberDeleteMutation$variables = {
  id: string;
  connections: ReadonlyArray<string>;
};
export type teamMemberDeleteMutation$data = {
  readonly deleteTeamMember: {
    readonly id: string;
  };
};
export type teamMemberDeleteMutation = {
  variables: teamMemberDeleteMutation$variables;
  response: teamMemberDeleteMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "teamMemberDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "TeamMemberDeletePayload",
        "kind": "LinkedField",
        "name": "deleteTeamMember",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "teamMemberDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "TeamMemberDeletePayload",
        "kind": "LinkedField",
        "name": "deleteTeamMember",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteEdge",
            "key": "",
            "kind": "ScalarHandle",
            "name": "id",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "abb9164f5f89e42d30dad2b6c7bf4599",
    "id": null,
    "metadata": {},
    "name": "teamMemberDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation teamMemberDeleteMutation(\n  $id: ID!\n) {\n  deleteTeamMember(id: $id) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "6024bcdb165cf575ce0413b7931a8eae";

export default node;
